<template>
  <div class="animated fadeIn">
    <b-row class="pageTitle">
      <b-col cols="12" class="d-flex mb-3">
        <h3 class="m-0">Danh sách logs</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <transition name="slide">
          <b-card>
            <div v-if="pages && pages.rows">
              <b-table hover :items="pages.rows" :fields="fields"></b-table>
              <nav v-if="pages && pages.totalPages > 1" class="d-flex justify-content-center">
                <b-pagination size="sm" :total-rows="pages.total" :per-page="pages.pageSize" v-model="pages.page"/>
              </nav>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import moment from 'moment-timezone';
import {isAuth, isSuperAdmin} from "@/utils/auth";
export default {
  name: "LogList",
  data () {
    return {

      loading: false,
      result: null,
      data: null,
      pages: {
        rows: null,
        page: 1
      },
      limit: 20,
      fields: [
        {key: 'email',label: 'Tài khoản'},
        {key: 'title',label: 'Mô tả'},
        {key: 'action',label: 'Hoạt động'},
        {key: 'note',label: 'Ghi chú'},
        {key: 'createdAt',label: 'Thời gian', formatter: "formatDate"},
      ],
    }
  },
  watch: {
    "pages.page": function (val) {
      this.fetchData(val);
    },
  },
  methods: {
    async fetchData(page = null) {
      try {
        this.loading = true
        const params = {
          sort: "-createdAt",
          pageSize: 10,
        }
        if (page > 0) {
          params.page = page
        }
        const {data} = await this.$axios.get(this.$configs.api + '/api/cp/logs', {params})

        const user = this.$cookies.get('user');
        this.$gtag.event('get_log_list', {
          event_category: 'log_events',
          event_label: 'List logs',
          user_type: 'admin',
          user_id: user?._id,
          qs: JSON.stringify(params) || null,
          result: {
            total: data?.total
          }
        });

        if (data) {
          this.pages = data
        }
        if (data && data.rows) {
          this.data = data.rows
        }
        if (data && data.totalPages) {
          this.pages.count = data.totalPages
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return moment(date).tz('Asia/Ho_Chi_Minh').format('DD-MM-YYYY H:mm');
    },
  },
  mounted() {
    if (!isAuth() || !isSuperAdmin()) {
      this.$router.push('/login')
    }
    this.fetchData()
  }

}
</script>

<style scoped>

</style>
